type PaymentRequirement = {
  scheme?: unknown;
  network?: unknown;
  asset?: unknown;
  amount?: unknown;
  payTo?: unknown;
};

type PaymentRequired = {
  accepts?: unknown;
  error?: unknown;
};

function decodeBase64Json<T>(value: string): T {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
  const bytes = Uint8Array.from(atob(padded), character => character.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes)) as T;
}

const PAYMENT_FAILURE_MESSAGES: Record<string, string> = {
  no_facilitator_for_network: "支付通道尚未就绪，请联系管理员或稍后重试",
  invalid_exact_evm_insufficient_balance: "当前钱包的 Base Sepolia USDC 余额不足",
  invalid_exact_evm_signature: "钱包签名无效，请确认使用当前连接的钱包重新签名",
  invalid_exact_evm_payload_authorization_valid_before: "支付授权已过期，请重新发起调用并及时完成签名",
  invalid_exact_evm_payload_authorization_valid_after: "支付授权尚未生效，请检查设备时间后重试",
  invalid_exact_evm_payload_authorization_value_mismatch: "支付授权金额与产品报价不一致",
  invalid_exact_evm_payload_authorization_value: "支付授权金额无效",
  invalid_exact_evm_nonce_already_used: "该支付授权已经使用，请重新发起调用",
};

export function paymentFailureMessageFromHeader(header: string | null): string | undefined {
  if (!header) return undefined;
  try {
    const challenge = decodeBase64Json<PaymentRequired>(header);
    if (typeof challenge.error !== "string" || !challenge.error.trim()) return undefined;
    const code = challenge.error.trim();
    const message = PAYMENT_FAILURE_MESSAGES[code];
    return message ? `${message}（${code}）` : `Facilitator 拒绝支付：${code}`;
  } catch {
    return undefined;
  }
}

export function assertExpectedPaymentChallenge(
  header: string | null,
  expected: {
    scheme?: "exact" | "batch-settlement";
    network: string;
    tokenAddress: string;
    amount: string;
    payTo: string;
  },
): void {
  if (!header) throw new Error("402 响应缺少 PAYMENT-REQUIRED");
  const challenge = decodeBase64Json<PaymentRequired>(header);
  if (!Array.isArray(challenge.accepts) || challenge.accepts.length !== 1) {
    throw new Error("付款报价数量异常，已停止签名");
  }
  const requirement = challenge.accepts[0] as PaymentRequirement;
  const matches =
    (!expected.scheme || requirement.scheme === expected.scheme) &&
    requirement.network === expected.network &&
    typeof requirement.asset === "string" &&
    requirement.asset.toLowerCase() === expected.tokenAddress.toLowerCase() &&
    requirement.amount === expected.amount &&
    typeof requirement.payTo === "string" &&
    requirement.payTo.toLowerCase() === expected.payTo.toLowerCase();
  if (!matches) throw new Error("付款报价与产品定价不一致，已停止签名");
}
